"use strict";

import "./Pager.css";
import React from "react";
import classnames from "classnames";

export default class Pager extends React.Component {
		
	renderPage(page, active) {
		return (
			<div key={page.props.id} className={classnames({"Hidden" : !active}, page.props.className)}>
				{page.props.children}
			</div>
		);
	}
	
	render() {
		return (
			<div className="Pager">
				{forceArray(this.props.children).map((page, index) => {
					let active = "active" in this.props ? (this.props.active == page.props.id) : (index==0);
					return this.renderPage(page, active);
				})}
			</div>
		);
	}
	
}

Pager.propTypes = {
	active: React.PropTypes.string
};

function forceArray(_) {
	return _.constructor === Array ? _ : [_];
}


// WEBPACK FOOTER //
// ./~/vwa/components/Pager/Pager.jsx